module.exports = __webpack_public_path__ + "img/email.6d569ed8.png";